import { DynamicFormDto, FieldType } from '@hqo/dynamic-forms-sdk/types';
import { DynamicFormBuilder } from '@hqo/dynamic-forms-sdk/builder';
import { formatDate } from '../../utils/dateFormatting';
import { FormField } from '@hqo/dynamic-forms-sdk/form';
import { useLocale } from 'hooks/use-locale.hook';

export interface FormAnswer {
  question: string;
  answer: string;
}

const prepareFieldValue = (field: FormField, locale: string) => {
  const stringValue = field.value.toString();

  return field.type === FieldType.DATE ? formatDate(stringValue, undefined, locale) : stringValue;
};

export const useFormAnswers = (form: DynamicFormDto): FormAnswer[] => {
  const locale = useLocale();
  const formData = DynamicFormBuilder.fromJSON(form).build();
  const fields = formData.steps.flatMap(step => step.fields);

  return fields
    .filter(field => field.value !== null)
    .map(field => ({ question: field.label, answer: prepareFieldValue(field, locale) }));
};
